import Fetcher from "@http/fetcher";

import { ResCallback } from "@interfaces/common";
import {
  CreateResponsibilityDirectoryPropsT,
  GetResponsibilityDocumentsResT,
} from "@interfaces/requests/responsibility";
import {
  ResponsibilityDirectoryT,
  ResponsibilityFileT,
} from "@interfaces/responsibility";
import { ResponsibilityRequestTypeEnum } from "@pages/responsibility";

class ResponsibilityService {
  static async GetResponsibilityDocuments(
    directoryId: number | null,
    cb: ResCallback<GetResponsibilityDocumentsResT>
  ) {
    try {
      const res = await Fetcher.get<GetResponsibilityDocumentsResT>(
        `/responsibility/directories/${directoryId || 0}`,
        {
          params: {
            directoryId: directoryId || 0,
            type: ResponsibilityRequestTypeEnum.RESPONSIBILITY,
          },
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async CreateDirectory(
    data: CreateResponsibilityDirectoryPropsT,
    cb: ResCallback<ResponsibilityDirectoryT>
  ) {
    try {
      const res = await Fetcher.post<ResponsibilityDirectoryT>(
        "/responsibility/directories",
        data,
        {
          params: {
            type: ResponsibilityRequestTypeEnum.RESPONSIBILITY,
          },
        }
      );

      if (res.status === 201) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async UploadFiles(
    formData: FormData,
    directoryId: number,
    cb: ResCallback<ResponsibilityFileT[]>
  ) {
    formData.set("directoryId", String(directoryId));

    try {
      const res = await Fetcher.post<ResponsibilityFileT[]>(
        "/responsibility/files",
        formData,
        {
          params: {
            type: ResponsibilityRequestTypeEnum.RESPONSIBILITY,
          },
        }
      );

      if (res.status === 201) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async UpdateFile(id: number, name: string, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.put<string>(`/responsibility/files/${id}`, {
        name,
      });

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async UpdateDirectory(
    id: number,
    name: string,
    cb: ResCallback<string>
  ) {
    try {
      const res = await Fetcher.put<string>(
        `/responsibility/directories/${id}`,
        { name }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async DeleteFile(fileId: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/responsibility/files/${fileId}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async DeleteDirectory(directoryId: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/responsibility/directories/${directoryId}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }
}

export default ResponsibilityService;
